const toText = (value: any): string => String(value ?? "").trim().toLowerCase();

const hasAny = (source: string, words: string[]): boolean =>
  words.some((w) => source.includes(w));

const getStateSignalText = (invoice: any): string => {
  const parts = [
    invoice?.stateName,
    invoice?.stateCode,
    invoice?.stateValue,
    invoice?.fixedState,
    invoice?.statusCode,
    invoice?.statusValue,
    invoice?.state,
  ];
  return toText(parts.filter((x) => x !== undefined && x !== null).join(" "));
};

export const isPaidState = (invoice: any): boolean => {
  const text = getStateSignalText(invoice);
  if (!text) return false;
  if (hasAny(text, ["partially paid", "partial paid", "castecne", "částe"])) return false;
  if (/(^|\s)4(\s|$)/.test(text)) return true;
  return hasAny(text, [" paid", "zaplac", "uhrazen"]);
};

export const isPartiallyPaidState = (invoice: any): boolean => {
  const text = getStateSignalText(invoice);
  if (!text) return false;
  if (/(^|\s)5(\s|$)/.test(text)) return true;
  return hasAny(text, ["partially paid", "partial paid", "partially", "castecne", "částe"]);
};

export const isApprovedState = (invoice: any): boolean => {
  const text = getStateSignalText(invoice);
  if (!text) return false;
  if (/(^|\s)3(\s|$)/.test(text)) return true;
  return hasAny(text, ["approved", "schval", "approval"]);
};

export const isBilledState = (invoice: any): boolean => {
  const text = getStateSignalText(invoice);
  if (!text) return false;
  if (/(^|\s)8(\s|$)/.test(text)) return true;
  return hasAny(text, ["billed", "fakturo", "vyuct"]);
};

export const isFinanciallyLockedState = (invoice: any): boolean =>
  isApprovedState(invoice) || isPartiallyPaidState(invoice) || isPaidState(invoice) || isBilledState(invoice);
